import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from 'src/app/admin/reports/csat-builder/common/base-control-value-accessor.abstract';

@Component({
  selector: 'gcc-survey-negative-checkbox',
  templateUrl: './survey-negative-checkbox.component.html',
  styleUrls: ['./survey-negative-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SurveyNegativeCheckboxComponent),
      multi: true
    }
  ]
})
export class SurveyNegativeCheckboxComponent extends BaseControlValueAccessor<any> implements OnInit {
  @Input() options: { id: string; text: string }[] = [];
  @Output() onValueChanged = new EventEmitter();
  list: { id: string | number; text: string }[];
  form: FormGroup;

  ngOnInit(): void {
    this.list = [
      ...this.options,
      {
        id: -1,
        text: 'other'
      }
    ];

    this.form = new FormGroup({
      list: new FormArray(
        this.list.map(option => {
          return new FormGroup({
            id: new FormControl(option.id),
            text: new FormControl(option.text),
            checked: new FormControl(false)
          });
        })
      )
    });

    this.form.valueChanges.subscribe(value => {
      this.onValueChanged.emit(value);
    });
  }
}
